<template>
<div>
    <GoogleMapMarker
        v-for="marker in markers"
        :key="marker.id"
        :marker="marker"
        :google="google"
        :map="map"
        :icon="{ url: marker.icon, w: 36, h: 50 }"
        :visible="marker.isVisible"
        @marker:click="$emit('marker:click', $event)"
    />
</div>
</template>

<script>
import MarkerClusterer from '@google/markerclustererplus'
import GoogleMapMarker from './GoogleMapMarker.vue'
import { OverlappingMarkerSpiderfier } from '../../../vendors/oms'

export default {
    components: {
        GoogleMapMarker,
    },

    props: {
        google: { type: Object, required: true },
        map: { type: Object, required: true },
        markers: { type: Array, required: true },
        objetTouristique: { type: Object, required: false },
    },

    data() {
        return {
            gmapCluster: null,
            gmapClusterSpider: null,
            gmapMarkers: [],
            firstInit: true,
        }
    },

    mounted() {
        this.gmapClusterSpider = new OverlappingMarkerSpiderfier(this.map, { markersWontMove: true })
        this.gmapMarkers = this.$children.map(child => child.mapMarker)

        this.gmapCluster = new MarkerClusterer(
            this.map,
            this.gmapMarkers,
            {
                imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                maxZoom: 15, // to remove cluser on level of zoom
            },
        )
    },

    computed: {
        visibleMarkers() {
            return this.$children.filter(marker => marker.visible)
        },
    },

    watch: {
        markers: function (newMarkers, oldMarkers) { // eslint-disable-line
            this.$nextTick(() => {
                this.gmapClusterSpider.forgetAllMarkers()
                this.visibleMarkers.forEach(({ mapMarker }) => { this.gmapClusterSpider.addMarker(mapMarker) })

                this.gmapCluster.clearMarkers()
                this.gmapCluster.addMarkers(this.visibleMarkers.map(item => item.mapMarker))
                if (!this.objetTouristique) {
                    this.fitMapToMarkers()
                }
            })
        },
    },

    methods: {
        fitMapToMarkers() {
            // const visibleMarkers = this.$children.filter(marker => marker.visible)
            const bounds = new this.google.maps.LatLngBounds()
            this.visibleMarkers.forEach(marker => bounds.extend(marker.mapMarker.position))
            this.map.fitBounds(bounds)
            if (this.firstInit) {
                this.google.maps.event.addListenerOnce(this.map, 'idle', () => {
                    this.firstInit = false
                    this.$emit('bounds:minzoom', this.map.getZoom())
                })
            }
        },
    },
}
</script>
